import { muiGlobalTheme } from '@/muiGlobalTheme';

export const stylesButtonMenuText = {
  display: 'inline-block',
  minWidth: '30px',
  mr: muiGlobalTheme.spacing(1),
};
